// GoogleAnalyticsHelper.ts
import ReactGA from "react-ga4";
import { AppHelper } from "./appHelper";

export class GoogleAnalyticsHelper {
  public static initialize(trackingIds: string[]): void {
    const options = [];
    trackingIds.forEach((trackingId) => {
      if (AppHelper.isNotEmpty(trackingId)) {
        options.push({
          trackingId: trackingId,
        });
      }
    });
    ReactGA.initialize(options);
  }

  public static pageview(path: string, title: string): void {
    ReactGA.send({
      hitType: "pageview",
      page: path,
      title: title,
    });
  }

  public static event(category: string, action: string, label: string): void {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
}

export default GoogleAnalyticsHelper;
